<template>
  <div class="collapse-item">
    <div header-tag="header" role="tab">
      <div v-b-toggle:[id] class="d-flex flex-column justify-content-between">
        <div class="d-flex justify-content-between">
          <h5>{{ title }}</h5>
          <div class="d-flex align-items-center">
          <span class="indicator-close">
            <label>{{ $t('fleetTaskInstant.text.open') }}</label> <i class="mc-fa icon-fill_arrow-ios-down" />
          </span>
          <span class="indicator-open">
            <label>{{ $t('fleetTaskInstant.text.close') }}</label> <i class="mc-fa icon-fill_arrow-ios-up" />
          </span>
        </div>
        </div>
        <div class="d-flex flex-column gap-1">
          <template v-if="liveTrack">
            <div class="__info-summary">
              <span>Total:</span>
              <span class="__spacing">
                <strong>{{ pointLength }}</strong> {{ $t('global.text.destination') }}
              </span>
              <span class="__spacing">
                <span class="__separator" />
                <span>
                  <strong>{{ (liveTrack?.total_distance / 1000) | formatNumber }}</strong> km
                </span>
              </span>
              <span class="__spacing">
                <span class="__separator" />
                <span>
                  {{
                    formatDuration(liveTrack?.total_duration, true, {
                      days: true,
                      hours: true,
                      minutes: true,
                    })
                  }}
                </span>
              </span>
            </div>

            <div class="time-info">
              {{ liveTrack.status.raw_type === 'ENDED' ? `${$t('fleetTaskInstant.text.completedOn')}: ` : `${$t('fleetTaskInstant.text.estimatedCompletion')}: ` }}
              <span>
                {{
                  liveTrack.status.raw_type === 'ENDED'
                    ? `${formatIndexDate(liveTrack?.actual_arrival_on).date}, ${
                        formatIndexDate(liveTrack?.actual_arrival_on).time
                      }`
                    : `${formatIndexDate(liveTrack?.estimated_arrival_on).date}, ${
                        formatIndexDate(liveTrack?.estimated_arrival_on).time
                      }`
                }}
              </span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <b-collapse :id="id" visible :accordion="accordion" role="tabpanel">
      <slot />
    </b-collapse>
  </div>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'
import { formatDuration } from '../../../lib/helpers/formatValues'

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    accordion: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    liveTrack: {
      type: Object,
      default: () => {},
    },
    pointLength: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatIndexDate,
    formatDuration,
  },
}
</script>

<style lang="scss" scoped>
.collapse-item {
  padding: 15px;
  border: 1px solid $teal-100;
  border-radius: 5px;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  .__info-summary {
    margin-top: 8px;
    display: block;
    gap: 8px;
    align-items: center;
    font-size: 12px;
    color: $mep-color-text-400;

    .__spacing {
      margin-left: 8px;
    }

    .__separator {
      display: inline-block;
      height: 4px;
      width: 4px;
      border-radius: 100%;
      background-color: $mep-color-text-200;
      margin-right: 4px;
    }
  }

  .time-info {
    font-size: 12px;
    font-weight: 400;
    color: $mep-color-text-300;

    span {
      font-weight: 500;
      color: $mep-secondary;
    }
  }

  h5 {
    font-size: 14px;
    margin-bottom: 0;
    cursor: pointer;
    color: $mep-color-text;
  }

  .mc-fa {
    cursor: pointer;
    &:before {
      color: $mep-primary !important;
    }
  }

  .indicator-close label,
  .indicator-open label {
    color: $mep-primary;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
    margin: 0;
  }

  .indicator-open {
    display: none;
  }

  .not-collapsed {
    .indicator-open {
      display: block;
    }
    .indicator-close {
      display: none;
    }
  }

  .collapse {
    padding-top: 15px;
    margin-top: 15px;
    border-top: 1px solid $teal-100;
  }
}

@media (max-width: 890px) {
  .time-info {
    display: none;
  }
}
</style>
